module.exports = __webpack_public_path__ + "static/media/SSG.444db4d7.png";